import { IMetaData, ITableHeaders } from '@Models/common.model'
import { CommonService } from '@Services/common.service'
import moment from 'moment'

const initMetadata: IMetaData = {
    limit: 10,
    offset: 0,
    total: 0,
}

interface IColumnData {
    header: ITableHeaders
    data: any
    rowIndex: number
    metadata: IMetaData | undefined
}

const ColumnData = (props: IColumnData) => {
    // core section
    const { header, data, rowIndex, metadata = initMetadata } = props
    const { formatType, key, render } = header

    const addDefaultSrc = (ev: any) => {
        console.log('asdfsad')

        // eslint-disable-next-line no-param-reassign
        ev.target.src = 'some default image url'
    }

    const formattedData = () => {
        switch (formatType) {
            case 'date':
                return data[key]
                    ? moment(data[key]).format('DD MMM, YYYY hh:mm A')
                    : ''
            case 'no':
                return metadata?.offset
                    ? +metadata?.offset + +rowIndex
                    : rowIndex + 1
            case 'image':
                return data[key] ? (
                    <img
                        src={data[key]}
                        alt="img"
                        className="table-img"
                        onError={addDefaultSrc}
                    />
                ) : (
                    <img
                        src={require('@Images/icons/camera-icon.svg').default}
                        className="table-default-img"
                        alt="img"
                    />
                )
            case 'currency':
                return CommonService.currencyFormat(data[key] || 0)

            default:
                return data[key] || ''
        }
    }
    // main
    return <div>{(render && render(rowIndex, data)) || formattedData()}</div>
}

export default ColumnData
